import { LS } from '@/const'
import ActionText from "@/components/action-text/action-text.vue"
import GetterWrapper from "@/components/getter-wrapper/getter-wrapper.vue"
import ItemReward from "@/components/item-reward/item-reward.vue"
import ItemTransaction from "@/components/item-transaction/item-transaction.vue"
import ViewDetails from "@/components/view-details/view-details.vue"
import ViewHeader from "@/components/view-header/view-header.vue"

import { getCard, getExpirations } from '@/store/api'

export default {
  name: 'Rewards',
  components: {
    ActionText,
    GetterWrapper,
    ItemReward,
    ItemTransaction,
    ViewDetails,
    ViewHeader
  },
  props: {},
  computed: {},
  data () {
    return {
      apiLoad: [
        {
          api: getCard,
          data: { id: this.$route.params.id }
        },
        {
          api: getExpirations,
          data: { id: this.$route.params.id, offset: 0, size: LS.CARD_TRANSACTION_SIZE }
        },
      ],
      card: {},
      currentOffset: 0,
      transactions: [],
      expirations: [],
      hasMoreExpirations: true,
      indexCurrent: -1,
      indexPassed: -1,
    }
  },
  created: function () { },
  mounted: function () { /* DOM accessible via this.$el */ },
  beforeUnmount: function () { /* clean all non-Vue listeners/objects */ },
  methods: {
    onData (data) {
      // Data first request
      this.card = data[0]
      // Data second request
      if (data[1].transactions.length < LS.CARD_TRANSACTION_SIZE) this.hasMoreExpirations = false
      console.log("Onload exp",data)
      this.transformExpiration(data[1])
    },
    async addExpirations () {
      try {
        const res = await getExpirations({ id: this.$route.params.id, offset: this.currentOffset + LS.CARD_TRANSACTION_SIZE, size: LS.CARD_TRANSACTION_SIZE })
        if (res.data.transactions.length < LS.CARD_TRANSACTION_SIZE) this.hasMoreExpirations = false

        this.transformExpiration(res.data)
        this.currentOffset += LS.CARD_TRANSACTION_SIZE
      } catch (error) {
        console.error('[ERROR]', error)
      } finally {
        this.loadLoading = false

      }
    },

    transformExpiration (data) {
      data.transactions.forEach(trans => {
        console.log("trans",trans)
        trans.date = new Date(trans.date)
        if (trans.sens === 'CREDIT' /*&& (trans.amount - (trans.metas.ENTRY_AM_EXP ? trans.metas.ENTRY_AM_EXP : 0))*/) {
          console.log("trans to push",trans)
          this.expirations.push(trans)
        }
      })
      // this.expirations = this.expirations.slice().sort((a, b) => new Date(a.metas.DATE_EXPIR) - new Date(b.metas.DATE_EXPIR))

      console.log("exp:",this.expirations)
    },
    openCurrent (index) {
      this.indexCurrent = (this.indexCurrent === index) ? -1 : index
    },
    openPassed (index) {
      this.indexPassed = (this.indexPassed === index) ? -1 : index
    },
  }
}
